// import "./EarningsInfoFieldsTableStyle.css";

// import { FC, useEffect, useRef, useState } from "react";

// import { Column } from "primereact/column";
// import { DataTable } from "primereact/datatable";
// import { InputText } from "primereact/inputtext";
// import { formatAmountCommaSeperator } from "../../../../common/Common";
// import { InputNumber } from "primereact/inputnumber";
// import { Typography } from "@mui/material";

// let columns = [
//   { field: "hoursType", headerName: "Hours Type", footer: "Total" },
//   { field: "rate", headerName: "Rate", },
//   { field: "hours", headerName: "Hours", },
//   { field: "amount", headerName: "Amount", footer: "800.00" },
// ];

// interface IEarningsInfoFieldsTable {
//   earningsTableUpdatedData: (data: any) => void;
//   earningsFieldsDataItems: any;
// }
// export const EarningsInfoFieldsTable: FC<
//   IEarningsInfoFieldsTable
// > = ({ earningsTableUpdatedData, earningsFieldsDataItems, }) => {

//   const [earningssTable, setEarningsTable] = useState<any>(
//     earningsFieldsDataItems
//   );

//   useEffect(() => {
//     earningsTableUpdatedData(earningssTable);
//   }, [earningssTable]);

//   useEffect(() => {
//     setEarningsTable(earningsFieldsDataItems);
//   }, [earningsFieldsDataItems]);


//   const onCellValueChange = (event: any, rowIndex: number, field: any) => {
//     setEarningsTable((prev: any) => {
//       const updatedData = [...prev];

//       const updatedRow = { ...updatedData[rowIndex], [event.field]: field };

//       updatedData[rowIndex] = updatedRow;
//       return updatedData;
//     });
//   };

//   const columnsBody = (rowData: any, row: any, x: any) => {
//     if (x.field === "hoursType") {
//       return (
//         <InputText
//           value={rowData[x.field] ?? ""}
//           onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
//           style={{ borderRadius: "2px" }}
//           readOnly
//         />

//       );
//     }
//     else if (
//       x.field === "hours"
//     ) {
//       return (
//         <InputNumber
//           value={rowData[x.field] ?? ""}
//           onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
//           placeholder="0.00"
//           minFractionDigits={2}
//           maxFractionDigits={2}
//           inputStyle={{ textAlign: "right" }}
//         />
//       );
//     }
//     else if (
//       x.field === "rate" ||
//       x.field === "amount"
//     ) {
//       return (
//         <span>
//           {rowData[x.field] !== null && rowData[x.field] !== undefined
//             ? `$ ${formatAmountCommaSeperator(rowData[x.field])}`
//             : rowData[x.field]}
//         </span>
//       );
//     }
//     return <span>{formatAmountCommaSeperator(rowData[x.field])}</span>;
//   };


//   return (
//     <>
//       <div className="card">
//         <DataTable
//           value={earningssTable}
//           dataKey="id"
//           showGridlines
//           className="EarningsInfoFieldsTableStyle"
//           editMode="cell"
//           // resizableColumns
//           columnResizeMode="expand"
//           scrollable
//           // reorderableColumns
//           filterDisplay="menu"
//           scrollHeight="416px"
//         >
//           {columns.map((x: any, index: any) => {
//             return (
//               <Column
//                 key={index}
//                 field={x.field}
//                 header={x.headerName}
//                 columnKey={x.field}
//                 footer={x.footer}
//                 style={{
//                   fontSize: "0.875rem",
//                 }}
//                 body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
//               />
//             );
//           })}
//         </DataTable>
//       </div>
//     </>
//   );
// };
import "./EarningsInfoFieldsTableStyle.css";

import { FC, useEffect, useState } from "react";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { formatAmountCommaSeperator } from "../../../../common/Common";
import { InputNumber } from "primereact/inputnumber";
import { Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

let columns = [
  { field: "hoursType", headerName: "Hours Type", footer: "Total" },
  { field: "rate", headerName: "Rate" },
  { field: "hours", headerName: "Hours" },
  { field: "amount", headerName: "Amount", footer: "800.00" },
];

let grossColumns = [
  { field: "label", headerName: "" },
  { field: "amount", headerName: "" },
];

export let grossItemsInitialData = [
  {
    id: "1",
    label: "Gross",
    amount: null,
  },
  {
    id: "2",
    label: "Vacation Pay",
    amount: null,
  },
  {
    id: "3",
    label: "Holiday Hours Worked on Jan 01 2026",
    amount: null,
  },
  {
    id: "4",
    label: "Holiday Hours Worked on Jan 06 2026",
    amount: null,
  },
  {
    id: "5",
    label: "Holiday Pay",
    amount: null,
  },
  {
    id: "6",
    label: "Commission Payment",
    amount: null,
  },
];
interface IEarningsInfoFieldsTable {
  earningsTableUpdatedData: (data: any) => void;
  earningsFieldsDataItems: any;
}
export const EarningsInfoFieldsTable: FC<
  IEarningsInfoFieldsTable
> = ({ earningsTableUpdatedData, earningsFieldsDataItems, }) => {

  const theme = useTheme();
  const [earningssTable, setEarningsTable] = useState<any>(
    earningsFieldsDataItems
  );

  // same pattern as earningssTable, just for the Gross section
  const [grossTable, setGrossTable] = useState<any>(grossItemsInitialData);
  const [grossAmount, setGrossAmount] = useState<number | null>(null);

  useEffect(() => {
    earningsTableUpdatedData(earningssTable);
  }, [earningssTable]);

  useEffect(() => {
    setEarningsTable(earningsFieldsDataItems);
  }, [earningsFieldsDataItems]);

  const onCellValueChange = (event: any, rowIndex: number, field: any) => {
    setEarningsTable((prev: any) => {
      const updatedData = [...prev];
      const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
      updatedData[rowIndex] = updatedRow;
      return updatedData;
    });
  };

  const onGrossCellValueChange = (event: any, rowIndex: number, field: any) => {
    setGrossTable((prev: any) => {
      const updatedData = [...prev];
      const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
      updatedData[rowIndex] = updatedRow;
      return updatedData;
    });
  };

  const columnsBody = (rowData: any, row: any, x: any) => {
    if (x.field === "hoursType") {
      return (
        <InputText
          value={rowData[x.field] ?? ""}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
          style={{ borderRadius: "2px" }}
          readOnly
        />
      );
    } else if (x.field === "hours") {
      return (
        <InputNumber
          value={rowData[x.field] ?? ""}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
          placeholder="0.00"
          minFractionDigits={2}
          maxFractionDigits={2}
          inputStyle={{ textAlign: "right" }}
        />
      );
    } else if (x.field === "rate" || x.field === "amount") {
      return (
        <span>
          {rowData[x.field] !== null && rowData[x.field] !== undefined
            ? `$ ${formatAmountCommaSeperator(rowData[x.field])}`
            : rowData[x.field]}
        </span>
      );
    }
    return <span>{formatAmountCommaSeperator(rowData[x.field])}</span>;
  };

  const grossColumnsBody = (rowData: any, row: any, x: any) => {
    const subLabelValue = rowData.label === "Vacation Pay" ? "(Accrued)" : rowData.label === "Holiday Pay" ? "(Due)" : null;

    if (x.field === "amount") {
      return (
        <InputNumber
          value={rowData.amount ?? null}
          onChange={(e: any) => onGrossCellValueChange(x, row.rowIndex, e.value)}
          placeholder="0.00"
          minFractionDigits={2}
          maxFractionDigits={2}
          inputStyle={{ textAlign: "right" }}
        />
      );
    }

    if (x.field === "label") {
      if (rowData.label === "Gross") {
        return (
          <Typography sx={{ fontSize: "0.875rem", fontWeight: "bold", textAlign: "end" }}>
            Gross
          </Typography>
        );
      }

      else if (rowData.label === "Vacation Pay") {
        return (
          <Typography sx={{ fontSize: "0.875rem" }}>
            <Link
              to="#"
              className="no-underline"
              style={{ color: theme.palette.primary.light }}
            >
              {rowData.label}
            </Link>
            {subLabelValue && (
              <span style={{ padding: "0px 4px" }}>
                {subLabelValue}: {(rowData.subAmount ?? 0).toFixed(2)}
              </span>
            )}
          </Typography>
        );
      }

      else if (rowData.label === "Holiday Pay") {
        return (
          <Typography sx={{ fontSize: "0.875rem" }}>
            {rowData.label}
            {subLabelValue && (
              <span style={{ padding: "0px 4px" }}>
                {subLabelValue}: {(rowData.subAmount ?? 0).toFixed(2)}
              </span>
            )}
          </Typography>
        );
      }

      else if (rowData.label === "Commission Payment") {
        return (
          <Typography sx={{ fontSize: "0.875rem" }}>
            <Link
              to="#"
              className="no-underline"
              style={{ color: theme.palette.primary.light }}
            >
              {rowData.label}
            </Link>
          </Typography>
        );
      }

      //All other labels
      return (
        <Typography sx={{ fontSize: "0.875rem" }}>
          {rowData.label}
          {subLabelValue && (
            <span style={{ padding: "0px 4px" }}>
              {subLabelValue}: {(rowData.subAmount ?? 0).toFixed(2)}
            </span>
          )}
        </Typography>
      );
    }
    return <span>{rowData[x.field]}</span>;
  };

  return (
    <>
      <div className="card">
        <DataTable
          value={earningssTable}
          dataKey="id"
          showGridlines
          className="EarningsInfoFieldsTableStyle"
          editMode="cell"
          columnResizeMode="expand"
          scrollable
          filterDisplay="menu"
          scrollHeight="416px"
        >
          {columns.map((x: any, index: any) => (
            <Column
              key={index}
              field={x.field}
              header={x.headerName}
              columnKey={x.field}
              footer={x.footer}
              style={{ fontSize: "0.875rem" }}
              body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
            />
          ))}
        </DataTable>
      </div>

      <div className="card">
        <DataTable
          value={grossTable}
          dataKey="id"
          showGridlines
          className="EarningsInfoFieldsTableStyle GrossTable"
          editMode="cell"
          columnResizeMode="expand"
          scrollable
          filterDisplay="menu"
          showHeaders={false}
        >
          {grossColumns.map((x: any, index: any) => (
            <Column
              key={index}
              field={x.field}
              header={x.headerName}

              columnKey={x.field}
              style={{ fontSize: "0.875rem", }}
              body={(rowData: any, row: any) => grossColumnsBody(rowData, row, x)}
            />
          ))}
        </DataTable>
      </div>
    </>
  );
};